import { Link } from "react-router-dom";
import { getActorsByIds } from "@/lib/data";

export default function CastList({ castIds }: { castIds: string[] }) {
  const cast = getActorsByIds(castIds);
  if (cast.length === 0) return null;

  return (
    <section className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-6">
      <div className="flex items-center gap-3 mb-5">
        <span className="w-1.5 h-6 rounded-full bg-accent-500" />
        <h2 className="font-heading text-xl font-bold text-foreground-950">演员阵容</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {cast.map((actor) => (
          <Link
            key={actor.id}
            to={`/actor/${actor.id}`}
            className="group flex items-center gap-3 p-2.5 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
          >
            <div className="w-14 h-14 rounded-full overflow-hidden bg-background-200 shrink-0">
              <img
                src={actor.avatar}
                alt={actor.name}
                title={`${actor.name} - 漂亮的保姆`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="min-w-0">
              <p className="font-medium text-sm text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                {actor.name}
              </p>
              <p className="text-xs text-foreground-400 truncate mt-0.5">
                {actor.region}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}